var map = {
	"./desktop/image-xx99-mark-one-headphones.jpg": 1120,
	"./mobile/image-xx99-mark-one-headphones.jpg": 3514,
	"./tablet/image-xx99-mark-one-headphones.jpg": 4024
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6698;